import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-back-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './back-button.component.html',
  styleUrl: './back-button.component.scss',
})
export class BackButtonComponent {
  @Input() isLoading = false;
  @Input() isDisabled = false;
  @Input() buttonText = 'WSTECZ';
  @Output() clickEvent = new EventEmitter<void>();

  handleClick() {
    if (!this.isLoading && !this.isDisabled) {
      this.clickEvent.emit();
    }
  }
}
